export default "__VITE_ASSET__BhifolHL__"